import httpClient from "@/api/httpClient";
import {
  IWholesaleOrder,
  IWholesaleOrderPayload,
  IWholesaleOrderResponse,
} from "./wholesale.interface";

export const getWholesaleOrdersService = async (
  page: number = 0,
  limit: number = 10,
  sort: string = "",
  order: "asc" | "desc" | "" = "",
  search: string = ""
): Promise<IWholesaleOrderResponse> => {
  try {
    const params: any = {
      page,
      limit,
    };

    if (sort) {
      params.sort = sort;
    }
    if (order) {
      params.order = order;
    }
    if (search) {
      params.search = search;
    }

    const response = await httpClient.get("/v1/history/wholesale-orders", {
      params,
    });
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const getWholesaleOrderByIDService = async (
  id: string
): Promise<IWholesaleOrder> => {
  try {
    const response = await httpClient.get(`/v1/history/wholesale-orders/${id}`);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const addWholesaleOrderService = async (
  order: IWholesaleOrderPayload
) => {
  try {
    const response = await httpClient.post("/v1/sell/wholesale", order);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const updateWholesaleOrderService = async (
  id: string,
  order: IWholesaleOrderPayload
) => {
  try {
    const response = await httpClient.put(`/v1/sell/wholesale/${id}`, order);
    return response.data;
  } catch (e) {
    throw e;
  }
};
